import React, { useState } from "react";
import PropTypes from "prop-types";
import { NeoSideMenu, NeoSearch } from "../../../../components/Common";
import { EVENT_TYPES, TEST_TYPES, getEventStatus } from "../constants";
import { GLOBAL_STATUS, GLOBAL_STATUS_LABELS } from "../../../../constants/common";

/**
 * EventSidebar
 * Componente que renderiza a lista de Eventos no painel lateral do layout Master-Detail.
 * Migrado para o NeoSideMenu do Neo Design System.
 */
const EventSidebar = ({
    events = [],
    activeId,
    onSelect,
    onCreateNew,
    loading
}) => {
    const [searchQuery, setSearchQuery] = useState("");

    // Auxiliar para obter o nome do tipo de evento
    const getEventTypeName = (event) => {
        const typeVal = event?.type?.value || event?.type?.id || event?.type;
        const testTypeVal = event?.testType?.value || event?.testType?.id || event?.testType;

        const typeObj = EVENT_TYPES.find(t => t.value === typeVal);
        if (typeVal === "test" && testTypeVal) {
            const testObj = TEST_TYPES.find(t => t.value === testTypeVal);
            return `${typeObj?.label || "Evento"} - ${testObj?.label || "Desconhecido"}`;
        }
        return typeObj?.label || "Desconhecido";
    };

    // Filtrar eventos baseado na pesquisa local
    const filteredEvents = events.filter((event) =>
        event.name?.toLowerCase().includes(searchQuery.toLowerCase())
    );

    // Mapear eventos para o formato de itens do NeoSideMenu
    const sideMenuItems = filteredEvents.map((event) => {
        const typeVal = event?.type?.value || event?.type?.id || event?.type;
        const status = getEventStatus(event);
        return {
            id: event.id,
            label: event.name,
            description: getEventTypeName(event),
            badge: GLOBAL_STATUS_LABELS[status] || "Desconhecido",
            badgeVariant: status === GLOBAL_STATUS.ACTIVE ? "success" : "muted",
            icon: typeVal === "test" ? "mdi-arm-flex-outline" : "mdi-clipboard-list-outline"
        };
    });

    return (
        <NeoSideMenu
            title="Eventos"
            subtitle={`${events?.length || 0} cadastrados`}
            icon="mdi-calendar-star"
            loading={loading}
            items={sideMenuItems}
            activeId={activeId}
            onSelect={(id) => {
                const event = events.find((e) => e.id === id);
                if (event) onSelect(event);
            }}
            onAdd={onCreateNew}
            searchComponent={
                <NeoSearch
                    size="sm"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Buscar evento..."
                />
            }
        />
    );
};

EventSidebar.propTypes = {
    events: PropTypes.array,
    activeId: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    onCreateNew: PropTypes.func.isRequired,
    loading: PropTypes.bool
};

export default EventSidebar;
